import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginResponse, MFAChallengedResponse } from './models/login-response';
import { TokenRequest } from './models/token-request';
import { DeviceAccountsResponse } from './models/DeviceAccountsResponse';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly _httpClient = inject(HttpClient);

  supportCode: string | undefined;
  basePath: string = environment.authUrl + '/v2/authentication';

  token(sessionId: string, tokenRequest: TokenRequest) {
    return this._httpClient.post<LoginResponse | MFAChallengedResponse>(`${this.basePath}/authenticate/${sessionId}`, tokenRequest).pipe(
      tap((x) => {
        if (x && this.isMFAChallengedResponse(x)) {
          this.supportCode = x.supportControlCode;
        }
      }),
    );
  }

  isMFAChallengedResponse(response: LoginResponse | MFAChallengedResponse): response is MFAChallengedResponse {
    return (response as MFAChallengedResponse).authenticationToken !== undefined;
  }

  mfaLost(phoneNumber: string) {
    return this._httpClient.post(`${this.basePath}/mfa-lost`, { phoneNumber: phoneNumber });
  }

  mfaLostVerify(value: string) {
    return this._httpClient.post(`${this.basePath}/mfa-lost/verify`, { value: value });
  }

  getDeviceAccounts() {
    return this._httpClient.get<DeviceAccountsResponse>(`${this.basePath}/device-accounts`);
  }

  deleteDeviceAccount(uuid: string) {
    return this._httpClient.delete(`${this.basePath}/device-accounts/${uuid}`);
  }
}
